import { Link } from 'react-router'
import clsx from 'clsx'
import dayjs from 'dayjs'
import { AspectRatio, Button, Image } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import { Race } from './api'
import { getRankSuffix } from '../common/helpers'
import { Typography } from '../common/typography'
import { ReactComponent as Trophy } from '../assets/trophy.svg'
import circuit from '../assets/circuit.png'
import classes from './Races.module.css'

export default function RaceResult({
  race,
  baseLink,
}: {
  race: Race
  baseLink?: string
}) {
  const isDesktop = useMediaQuery('(min-width: 800px)')
  const hasVideo = !!race.video.main

  if (race.round_status === 'ended') {
    return (
      <div className={classes.raceResultContainer}>
        <div className={classes.endedRace}>
          <div className={classes.resultsWrapper} data-mobile={!isDesktop}>
            <Typography
              fs="sm"
              fw={500}
              lh="115"
              tt="uppercase"
              ta="center"
              className={classes.roundDescription}
            >
              Race <br /> complete
            </Typography>
            <div className={classes.divider} />
            {race.results && (
              <div className={classes.resultsContainer}>
                {race.results.slice(0, 3).map((result, index) => (
                  <div className={classes.teamRow} key={result.team_id}>
                    <Typography fs="sm" fw={600} lh="140">
                      {index + 1}
                      <sup>{getRankSuffix(index)}</sup>
                    </Typography>

                    <AspectRatio ratio={1 / 1}>
                      <Image
                        src={
                          isDesktop
                            ? result.team_logo.thumbnail
                            : result.team_logo.mini
                        }
                        alt={result.team_name}
                        className={clsx(classes.teamLogo, {
                          [classes.teamLogoMobile]: !isDesktop,
                        })}
                        fit="scale-down"
                      />
                    </AspectRatio>
                    <Typography
                      fw={index ? 400 : 600}
                      lh="150"
                      className={clsx(classes.team, {
                        [classes.withTrophy]: !index,
                      })}
                    >
                      {result.team_name}
                      {!index && (
                        <Trophy
                          className={clsx(classes.trophy, {
                            [classes.trophyMobile]: !isDesktop,
                          })}
                        />
                      )}
                    </Typography>
                  </div>
                ))}
              </div>
            )}
          </div>
          <div className={classes.buttonsContainer}>
            {hasVideo && (
              <Button
                component={Link}
                to={`${baseLink}/highlights`}
                className={clsx(classes.button, classes.watchButton)}
              >
                <Typography
                  fc={{ light: 'primary-5', dark: 'gray-3' }}
                  fs="sm"
                  lh="150"
                  ta="center"
                >
                  Watch Race
                </Typography>
              </Button>
            )}

            <Button
              component={Link}
              to={`${baseLink}/summary`}
              className={classes.button}
            >
              <Typography
                fc={{ light: 'white', dark: 'white' }}
                fs="sm"
                lh="150"
                ta="center"
              >
                Race Results
              </Typography>
            </Button>
          </div>
        </div>
      </div>
    )
  }
  return (
    <div className={classes.raceResultContainer}>
      <div className={classes.endedRace}>
        <div className={classes.resultsWrapper} data-mobile={!isDesktop}>
          <Typography
            fs="sm"
            fw={500}
            lh="115"
            tt="uppercase"
            ta="center"
            className={classes.roundDescription}
          >
            Upcoming <br /> race
          </Typography>
          <div className={classes.divider} />
          <div
            className={clsx(classes.track, {
              [classes.trackMobile]: !isDesktop,
            })}
          >
            <Image
              src={circuit}
              alt="Race circuit"
              className={classes.circuit}
            />
            <Typography fw={500} lh="125" className={classes.raceNumber}>
              {`Race ${race.round_number}`}
            </Typography>
          </div>
          <div className={classes.divider} />
          <Typography
            fs="sm"
            fw={500}
            ff="JetBrains Mono"
            lh="140"
            ta="center"
            className={classes.roundStartDate}
          >
            {dayjs(race.round_start).add(6, 'day').format('DD.MM.YYYY')}
          </Typography>
        </div>
      </div>
    </div>
  )
}
